export interface TaskAIPromptConfig {
  system: string;
  userTemplate: string;
}

export const TASK_GENERATION_PROMPTS: TaskAIPromptConfig = {
  system: `Du bist ein intelligenter Assistent für Projektmanagement und Aufgabenerstellung. Deine Aufgabe ist es, aus einer Benutzereingabe und optional aus E-Mail-Informationen strukturierte Aufgabeninformationen zu extrahieren und zu generieren.

REGELN:
1. Analysiere die Eingabe und extrahiere relevante Informationen
2. Erstelle einen klaren, prägnanten Titel (max. 100 Zeichen)
3. Formuliere eine detaillierte Beschreibung mit allen wichtigen Informationen
4. Identifiziere konkrete Arbeitsschritte und erstelle daraus eine Checkliste
5. Jeder Checklistenpunkt sollte eine klar abgrenzbare Aufgabe sein (max. 100 Zeichen pro Eintrag)
6. Verwende professionelle, sachliche Sprache
7. Bei E-Mail-Kontext: Beziehe Absender, Betreff und Inhalt mit ein
8. Sortiere Checklistenpunkte nach logischer Reihenfolge

WICHTIG: Gib NUR reines JSON zurück, KEINE Markdown-Formatierung, KEINE Code-Blöcke mit \`\`\`json, nur das reine JSON-Objekt!

OUTPUT FORMAT (strikt JSON ohne Markdown):
{
  "title": "string",
  "description": "string",
  "checklistItems": [
    {"title": "string", "isChecked": false}
  ]
}`,
  userTemplate: `Erstelle eine strukturierte Aufgabe aus folgenden Informationen:

BENUTZEREINGABE:
{{USER_INPUT}}

{{EMAIL_CONTEXT}}

Analysiere die Informationen und erstelle daraus:
1. Einen präzisen Titel
2. Eine umfassende Beschreibung
3. Eine Checkliste mit konkreten Arbeitsschritten

Gib NUR reines JSON zurück ohne \`\`\`json Markdown-Formatierung!`,
};

export function buildTaskGenerationPrompt(params: {
  userInput: string;
  emailSubject?: string;
  emailFrom?: string;
  emailBody?: string;
}): string {
  const { userInput, emailSubject, emailFrom, emailBody } = params;

  let emailContext = '';
  if (emailSubject || emailFrom || emailBody) {
    emailContext = 'E-MAIL KONTEXT:\n';
    if (emailFrom) emailContext += `Von: ${emailFrom}\n`;
    if (emailSubject) emailContext += `Betreff: ${emailSubject}\n`;
    if (emailBody) emailContext += `Inhalt: ${emailBody}\n`;
  } else {
    emailContext = 'E-MAIL KONTEXT:\nKein E-Mail-Kontext verfügbar';
  }

  return TASK_GENERATION_PROMPTS.userTemplate
    .replace('{{USER_INPUT}}', userInput)
    .replace('{{EMAIL_CONTEXT}}', emailContext);
}
